import React, { useState } from 'react';

import config from "../../../config";
import { IFinanceCalculatorState } from '../../../models/finance-calculator.model';
import { IFinanceCalculateRequest, IFinanceCalculateRequestVehicleRequests, IFinanceProductResults } from '../../../models/codeweavers.model';
import FinanceCalculatorResultsTable from './FinanceCalculatorResultsTable/FinanceCalculatorResultsTable';
import FinanceCalculatorFormSummary from '../FinanceCalculatorForm/FinanceCalculatorFormSummary/FinanceCalculatorFormSummary';

const FinanceCalculatorResults = ({ state, updateState, onApply }: { state: IFinanceCalculatorState, updateState: React.Dispatch<any>, onApply?: React.Dispatch<any> }) => {
    // const [value, setValue] = useState<IFinanceProductResults[]>([]);
    const [loading, setLoading] = useState(true);

    const parseCodeweaversResults = (results: any) => {
        let res: IFinanceProductResults[] = [];
        if (results.VehicleResults && (results.VehicleResults.length > 0)) {
            if (results.VehicleResults[0].FinanceProductResults && (results.VehicleResults[0].FinanceProductResults.length > 0)) {
                // eslint-disable-next-line
                results.VehicleResults[0].FinanceProductResults.map((fpr: IFinanceProductResults, i: number) => {
                    if (!fpr.HasError) {
                        res.push(fpr);
                    }
                }
                )
            }
        }
        return res;
    }

    const parseCodeweaversErrors = (results: any) => {
        let res: IFinanceProductResults[] = [];
        if (results.VehicleResults && (results.VehicleResults.length > 0)) {
            if (results.VehicleResults[0].FinanceProductResults && (results.VehicleResults[0].FinanceProductResults.length > 0)) {
                // eslint-disable-next-line
                results.VehicleResults[0].FinanceProductResults.map((fpr: IFinanceProductResults, i: number) => {
                    if (fpr.HasError) {
                        res.push(fpr);
                    }
                }
                )
            }
        }
        return res;
    }

    React.useEffect(() => {

        const getCodeweaversCalculateBody = () => {
            if (config.REACT_APP_CW_MOCK === "true") {
                return getCodeweaversCalculateMockBody()
            } else {
                return getCodeweaversCalculateNormalBody()
            }
        }
    
        const getCodeweaversCalculateNormalBody = () => {
            // console.log("getCodeweaversCalculateNormalBody: state = " + JSON.stringify(state));
            const keys = [];
            if (state.formdata?.showPCP) {
                keys.push("PCP");
            }
            if (state.formdata?.showHP || (keys.length === 0)) {
                keys.push("HP");
            }
            const payload: IFinanceCalculateRequest = {
                "Parameters": {
                    "Term": state.formdata?.term || 0,
                    "Deposit": state.formdata?.deposit,
                    "DepositType": "amount",
                    "FinanceProductFamilyKeys": keys,
                    "SellOut": { "Value": state.formdata?.apr || 0, "Type": "Apr" },
                    "AnnualMileage": state.formdata?.annualMileage
                },
            };
            payload.VehicleRequests = [];
            const dtNow = new Date();
            if (state.formdata?.vehicleBased && state.formdata?.knownRegNo) {
                const vehicle: IFinanceCalculateRequestVehicleRequests = {
                    "Id": dtNow.toISOString(),
                    "Vehicle": {
                        "CashPrice": state.formdata?.cashPrice || 0,
                        "CurrentMileage": state.formdata?.currentMileage,
                        "CurrentMileageUnit": "Miles",
                        "Identifier": state.formdata?.regNo,
                    },
                    "Channel": {
                        "Key": "DMS"
                    }
                }
                payload.VehicleRequests.push(vehicle);
            } else if (state.formdata?.vehicleBased && !state.formdata?.knownRegNo) {
                const yyyy = parseInt(state.formdata?.identity?.year || dtNow.getFullYear().toString());
                const dtReg = new Date(yyyy, 0, 1);
                const vehicle: IFinanceCalculateRequestVehicleRequests = {
                    "Id": dtNow.toISOString(),
                    "Vehicle": {
                        "CashPrice": state.formdata?.cashPrice || 0,
                        "CurrentMileage": state.formdata?.currentMileage,
                        "CurrentMileageUnit": "Miles",
                        "Identifier": state.formdata?.identity?.derivative,
                        "IdentifierType": "CapLongCode",
                        "RegistrationDate": dtReg.toISOString().slice(0, 10)
                    },
                    "Channel": {
                        "Key": "DMS"
                    }
                }
                payload.VehicleRequests.push(vehicle);
            } else {
                var newDate = new Date(dtNow.setMonth(dtNow.getMonth()-1));
                const vehicle: IFinanceCalculateRequestVehicleRequests = {
                    "Id": dtNow.toString(),
                    "Vehicle": {
                        "CashPrice": state.formdata?.cashPrice || 0,
                        "CurrentMileage": 0,
                        "CurrentMileageUnit": "Miles",
                        "RegistrationDate": newDate.toISOString().slice(0, 10)
                    },
                    "Channel": {
                        "Key": "DMS"
                    }
                }
                payload.VehicleRequests.push(vehicle);
            }
            let res = JSON.stringify(payload);
            // console.log("getCodeweaversCalculateNormalBody: " + res);
            return res;
        }
    
        const getCodeweaversCalculateMockBody = () => {
            const payload = {
                "Parameters": {
                    "Term": 48,
                    "Deposit": 5000,
                    "DepositType": "amount",
                    "FinanceProductFamilyKeys": ["HP"],
                    "SellOut": { "Value": 9.9 },
                    "AnnualMileage": 8000
                },
                "VehicleRequests": [
                    {
                        "Id": "FL71VZR",
                        "Vehicle": {
                            "CashPrice": 49500,
                            "CurrentMileage": 30300,
                            "CurrentMileageUnit": "Miles",
                            "Identifier": "FL71VZR"
                        },
                        "Channel": {
                            "Key": "DMS" //Might not be DMS for yourselves, TBC
                        }
                    }
                ]
            };
            return JSON.stringify(payload);
        }
    
        const fetchMockGet = () => {
            fetch(config.REACT_APP_BASE_URL + "/assets/data/mockCalculate.json", {
                method: "get",
                headers: {
                    "Accept": "application/json"
                }
            })
                .then((res) => res.json())
                .then((res) => {
                    // console.log("Get: " + JSON.stringify(res));
                    updateState({...state, resultsdata: parseCodeweaversResults(res), errordata: parseCodeweaversErrors(res)});
                    setLoading(false);
                })
        }

        const fetchCodeweaversPost = () => {
            fetch(config.REACT_APP_CW_URL + "/public/v3/jsonfinance/calculate", {
                method: "post", body: getCodeweaversCalculateBody(),
                headers: {
                    "Accept": "*/*",
                    "Content-Type": "application/json",
                    "X-CW-ApiKey": config.REACT_APP_CW_KEY || ""
                }
            })
                .then((res) => res.json())
                .then((res) => {
                    console.log("fetchCodeweaversPost returned: " + JSON.stringify(res));
                    updateState({...state, resultsdata: parseCodeweaversResults(res), errordata: parseCodeweaversErrors(res)});
                    setLoading(false);
                })
        }

        if (!state.resultsdata) {
            if (config.REACT_APP_CW_MOCK === "true") {
                fetchMockGet()
            } else {
                fetchCodeweaversPost()
            }
        } else {
            setLoading(false);
        }
    }, [state, updateState]);

    if (loading) {
        return <div>Loading...</div>;
    } else {
        return (
        <>
            <FinanceCalculatorFormSummary state={state} />
            <FinanceCalculatorResultsTable state={state} updateState={updateState} onApply={onApply} />
        </>);
    }
};

export default FinanceCalculatorResults;
